import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import './chartSetup';
import { CHART_COLORS, defaultChartOptions } from './chartSetup';

const BarChartCard = ({ title, labels = [], values = [], color = CHART_COLORS.purple, horizontal = false }) => {
  const chartData = useMemo(() => ({
    labels,
    datasets: [{
      label: title,
      data: values,
      backgroundColor: `${color}cc`,
      borderRadius: 6,
      maxBarThickness: horizontal ? 24 : 40
    }]
  }), [title, labels, values, color]);

  const options = useMemo(() => ({
    ...defaultChartOptions,
    indexAxis: horizontal ? 'y' : 'x',
    scales: {
      x: {
        grid: { display: horizontal },
        ticks: { color: '#6b7280' }
      },
      y: {
        beginAtZero: true,
        grid: { color: '#f3f4f6' },
        ticks: { color: '#6b7280', precision: 0 }
      }
    },
    plugins: {
      ...defaultChartOptions.plugins,
      legend: { display: false }
    }
  }), [horizontal]);

  if (!values.length) {
    return (
      <div className="h-56 flex items-center justify-center text-sm text-gray-500">
        No data available
      </div>
    );
  }

  return (
    <div>
      {title && <h3 className="text-base font-bold text-gray-900 mb-3">{title}</h3>}
      <div className="h-56" role="img" aria-label={`${title} bar chart`}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default BarChartCard;
